var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYogaMatError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 102 69",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#YogaMat-Error_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "m56.117 26.97 43.304.105c.761.003 1.284.773.999 1.485l-.071.178v.003L85.188 66.818a1.08 1.08 0 0 1-1.025.68 561.967 561.967 0 0 1-3.643-.082c-6.647-.187-23.086-.223-38.549-.535-7.752-.157-15.277-.383-21.26-.733-2.993-.175-5.588-.38-7.628-.622-2.08-.246-3.47-.517-4.132-.786-4.44-1.806-6.988-5.894-7.727-10.56-.741-4.68.369-9.795 3.085-13.43 2.983-3.991 7.135-6.248 11.294-6.526 4.14-.276 8.372 1.4 11.586 5.442 1.21 1.523 2.116 3.592 2.47 5.736.354 2.147.143 4.278-.758 5.973-.504.949-1.219 1.846-2.086 2.636l-.05.045-.042.051a10.616 10.616 0 0 1-8.153 3.806c-4.125 0-7.704-2.349-9.476-5.792l-.824-1.604-.924 1.55c-.425.713-.58 1.6-.36 2.544l.049.19c1.32 4.639 5.83 7.473 10.028 8.39 3.488.763 7.161-.126 10.3-1.88 2.943-1.644 5.504-4.095 7.095-6.836l.305-.551c4.044-7.69 9.214-14.698 14.04-22.122V31.8c.114-.177.226-.354.336-.532l.326-.534a7.743 7.743 0 0 1 6.652-3.764Z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "YogaMat-Error_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.231.035a12.936 12.936 0 0 0-.896-.034c.298-.005.597.006.896.034Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.231.035a12.936 12.936 0 0 0-.896-.034c.298-.005.597.006.896.034Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  d: "m39.231.035-.148 1.995.333-3.986-.185 1.991Zm-.896-.034-.039-2 .03 4 .01-2Zm.896.034.148-1.994A14.921 14.921 0 0 0 38.346-2l-.01 2-.01 2c.263.002.516.01.758.029L39.23.035Zm-.896-.034.04 2c.219-.004.442.004.671.026l.185-1.992.185-1.991a9.974 9.974 0 0 0-1.12-.042l.04 2Z",
  mask: "url(#YogaMat-Error_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M38.248 1h.04l.022.001h.022c.282.001.558.011.826.031h.004c6.524.465 11.691 5.867 11.8 12.504v.215c0 .426-.02.846-.06 1.259-.003.027-.005.056-.01.09l-.012.107c-.202 1.599-.767 3.21-1.767 4.757-.627.969-1.282 1.931-1.95 2.901-.81 1.174-1.641 2.362-2.45 3.565l-.8 1.207c-1.83 2.814-6.294 9.263-8.58 12.555a.353.353 0 0 1-.616-.063l-.006-.014-.223-.471c-1.167-2.372-3.138-4.924-5.007-6.64-4.034-3.703-8.997-5.318-14.408-5.164l-.508.02-.394.011 7.306-11.73.01-.015v-.001l3.192-5.123a30.13 30.13 0 0 0 .984-1.698l1.093-1.786c2.396-3.91 6.57-6.401 11.116-6.514v-.001c.124-.003.25-.003.376-.003Z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "YogaMat-Error_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.963 13.751c.004.451-.018.904-.066 1.358.044-.447.066-.9.066-1.358Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M51.963 13.751c.004.451-.018.904-.066 1.358.044-.447.066-.9.066-1.358Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  d: "m51.963 13.751 2-.02-4 .02h2Zm-.066 1.358-1.99-.195 3.979.406-1.989-.211Zm.066-1.358-2 .02c.003.373-.015.748-.055 1.127l1.989.21 1.989.212c.056-.53.082-1.06.077-1.588l-2 .02Zm-.066 1.358 1.99.195c.05-.513.076-1.03.076-1.553h-4c0 .395-.02.782-.056 1.163l1.99.195Z",
  mask: "url(#YogaMat-Error_svg__c)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "YogaMat-Error_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h101.5v68.5H0z"
})))));
SvgYogaMatError.viewBox = '0 0 102 69';
const ForwardRef = /*#__PURE__*/forwardRef(SvgYogaMatError);
export default ForwardRef;